export const SECTION_LIBRARY_METADATA = {
  hero: {
    label: 'Hero Banner',
    description: 'Large school intro banner with headline, media, and primary action.',
    category: 'School Essentials',
    recommended: true,
    libraryOrder: 10,
  },
  text: {
    label: 'School Overview',
    description: 'Simple introduction block for school overview, vision, or page intro.',
    category: 'School Essentials',
    recommended: true,
    libraryOrder: 20,
  },
  image: {
    label: 'Image + Details',
    description: 'Clean split layout for school overview, campus, or teaching details.',
    category: 'School Essentials',
    recommended: true,
    libraryOrder: 30,
  },
  experience_story: {
    label: 'School Story',
    description: 'Image-led section for school story, learning approach, or campus culture.',
    category: 'School Essentials',
    recommended: true,
    libraryOrder: 40,
  },
  icon_grid: {
    label: 'Facilities & Highlights',
    description: 'Grid for facilities, support areas, co-curriculars, or school strengths.',
    category: 'School Essentials',
    recommended: true,
    libraryOrder: 50,
  },
  tabs: {
    label: 'Academic Tabs',
    description: 'Tabbed content for curriculum stages, streams, or programmes.',
    category: 'Academics',
    recommended: true,
    libraryOrder: 60,
  },
  stats_strip: {
    label: 'School Facts',
    description: 'Quick school numbers like results, student count, ratios, and achievements.',
    category: 'Academics',
    recommended: true,
    libraryOrder: 70,
  },
  student_results_grid: {
    label: 'Achievements',
    description: 'Cards for toppers, competitions, awards, or academic recognition.',
    category: 'Academics',
    recommended: true,
    libraryOrder: 80,
  },
  results: {
    label: 'Results Table',
    description: 'Structured board results, grade performance, or summary outcomes.',
    category: 'Academics',
    recommended: true,
    libraryOrder: 90,
  },
  quote: {
    label: 'Principal Message',
    description: 'Principal, chairman, or leadership message with portrait and note.',
    category: 'Leadership & Trust',
    recommended: true,
    libraryOrder: 100,
  },
  profile_showcase: {
    label: 'Leadership / Alumni',
    description: 'Profiles for leadership, alumni, testimonials, or distinguished people.',
    category: 'Leadership & Trust',
    recommended: true,
    libraryOrder: 110,
  },
  image_grid: {
    label: 'Photo Gallery',
    description: 'Campus, events, classrooms, and student life gallery section.',
    category: 'Campus Life',
    recommended: true,
    libraryOrder: 120,
  },
  slider: {
    label: 'Campus Slider',
    description: 'Rotating media for campus life, events, and school highlights.',
    category: 'Campus Life',
    recommended: true,
    libraryOrder: 130,
  },
  overlay_banner: {
    label: 'Overlay Banner',
    description: 'Full-width visual section with layered title, description, and optional button.',
    category: 'School Essentials',
    recommended: true,
    libraryOrder: 135,
  },
  news_highlights: {
    label: 'News & Events',
    description: 'Updates, circulars, announcements, and recent school happenings.',
    category: 'Campus Life',
    recommended: true,
    libraryOrder: 140,
  },
  sidebar_content: {
    label: 'Admissions Details',
    description: 'Sticky admissions nav with guidance, documents, and next steps.',
    category: 'Admissions & Contact',
    recommended: true,
    libraryOrder: 150,
  },
  admissions_form: {
    label: 'Admissions Enquiry',
    description: 'Parent enquiry form for admissions and school visits.',
    category: 'Admissions & Contact',
    recommended: true,
    libraryOrder: 160,
  },
  contact_form: {
    label: 'Contact Enquiry',
    description: 'General contact form for parent questions and school support.',
    category: 'Admissions & Contact',
    recommended: true,
    libraryOrder: 170,
  },
  map: {
    label: 'Visit Us',
    description: 'Campus address, map, and visit directions section.',
    category: 'Admissions & Contact',
    recommended: true,
    libraryOrder: 180,
  },
  cta: {
    label: 'Admissions Callout',
    description: 'Strong action block for apply now, enquire, or book a visit.',
    category: 'Admissions & Contact',
    recommended: true,
    libraryOrder: 190,
  },
  social_links: {
    label: 'Social Links',
    description: 'Official school social channels and digital presence links.',
    category: 'Admissions & Contact',
    libraryOrder: 200,
  },
  subscribe: {
    label: 'Parent Updates',
    description: 'Email signup block for school notices and admissions reminders.',
    category: 'Admissions & Contact',
    libraryOrder: 210,
  },
  footer: {
    label: 'School Footer',
    description: 'Footer with address, contact details, and key page links.',
    category: 'Admissions & Contact',
    recommended: true,
    libraryOrder: 220,
  },
  careers_openings: {
    label: 'Careers',
    description: 'School hiring and careers listings.',
    category: 'School Essentials',
    libraryOrder: 230,
  },
  video: { builderVisible: false, libraryOrder: 900 },
  list: { builderVisible: false, libraryOrder: 901 },
  stages: { builderVisible: false, libraryOrder: 902 },
  faculty: { builderVisible: false, libraryOrder: 903 },
  founders: { builderVisible: false, libraryOrder: 904 },
  divider: { builderVisible: false, libraryOrder: 905 },
  button: { builderVisible: false, libraryOrder: 906 },
  image_only: { builderVisible: false, libraryOrder: 907 },
  image_read_more: { builderVisible: false, libraryOrder: 908 },
  custom_combo: { builderVisible: false, libraryOrder: 909 },
  dropdown: { builderVisible: false, libraryOrder: 910 },
  table: {
    label: 'Information Table',
    description: 'Fee heads, mandatory disclosures, schedules, or structured information.',
    category: 'School Essentials',
    libraryOrder: 240,
  },
};

export const buildSectionLibrary = (baseLibrary = []) =>
  baseLibrary
    .map((item) => ({
      ...item,
      ...(SECTION_LIBRARY_METADATA[item.id] || {}),
    }))
    .sort((firstItem, secondItem) => {
      const firstOrder = Number.isFinite(Number(firstItem.libraryOrder)) ? Number(firstItem.libraryOrder) : 9999;
      const secondOrder = Number.isFinite(Number(secondItem.libraryOrder)) ? Number(secondItem.libraryOrder) : 9999;
      if (firstOrder !== secondOrder) {
        return firstOrder - secondOrder;
      }
      return String(firstItem.label || '').localeCompare(String(secondItem.label || ''));
    });

export const getVisibleSectionLibrary = (sectionLibrary = []) =>
  sectionLibrary.filter((item) => item.builderVisible !== false);

export const searchSectionLibrary = (sectionLibrary = [], query = '') => {
  const normalizedQuery = String(query || '').trim().toLowerCase();
  const visibleSectionLibrary = getVisibleSectionLibrary(sectionLibrary);
  if (!normalizedQuery) {
    return visibleSectionLibrary;
  }
  return visibleSectionLibrary.filter(
    (item) =>
      String(item.label || '').toLowerCase().includes(normalizedQuery) ||
      String(item.description || '').toLowerCase().includes(normalizedQuery) ||
      String(item.category || '').toLowerCase().includes(normalizedQuery)
  );
};

export const getSectionTypeOptions = (sectionLibrary = [], currentType = '') => {
  const visibleSectionLibrary = getVisibleSectionLibrary(sectionLibrary);
  if (!currentType) {
    return visibleSectionLibrary;
  }
  const currentItem = sectionLibrary.find((item) => item.id === currentType);
  if (!currentItem) {
    return visibleSectionLibrary;
  }
  if (currentItem.builderVisible !== false) {
    return visibleSectionLibrary;
  }
  return [
    ...visibleSectionLibrary,
    {
      ...currentItem,
      label: currentItem.label || currentType,
    },
  ];
};
